export default `
query order($orderId: ID!) {
    order(orderId: $orderId) {
        id
        status
        totalAmount
        paymentMethodType
        ticketConfirmedCount
        gameSubscription {
            id
            cancelAt
        }
        player {
            firstName
            email
        }
    }
}
`;
